import React, { useState } from 'react';
import '../Styles/global.css';
import Layout from "../Components/Layout";

const EmployeeManager = () => {
    const [ingredients, setIngredients] = useState('');
    const [dishes, setDishes] = useState([]);
    const [notification, setNotification] = useState('');

    const handleAddDish = () => {
        if (ingredients.trim()) {
            setDishes([...dishes, { ingredients }]);
            setIngredients('');
            setNotification('Ingredient toegevoegd!');
            setTimeout(() => {
                setNotification('');
            }, 3000); 
        }
    };

    return (
        <Layout>
            <div className="employee-dashboard">
                <h1>AH Medewerker Dashboard</h1>
                <div className="employee-form-group">
                    <textarea
                        value={ingredients}
                        onChange={(e) => setIngredients(e.target.value)}
                        className="employee-input-field"
                        placeholder="Ingrediënten"
                    ></textarea>
                    <button onClick={handleAddDish} className="employee-add-button">
                        Toevoegen
                    </button>
                </div>
                <ul className="employee-dish-list">
                    {dishes.map((dish, index) => (
                        <li key={index} className="employee-dish-item">
                            <p><strong>Ingrediënten:</strong> {dish.ingredients}</p>
                        </li>
                    ))}
                </ul>
                {notification && <div className="employee-notification">{notification}</div>}
            </div>
        </Layout>
    );
};

export default EmployeeManager;
